import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { isLegacyCrmEnabled } from "../constants/featureFlags";
import { usePendingProducts } from "../hooks/usePromotedProducts";
import { usePendingExpertRequests } from "../hooks/useExperts";
import { getStoredAuthUser } from "../utils/backendApi";

const Navdata = () => {
  const history = useHistory();

  // Role from the stored session, through the helper and never straight from
  // sessionStorage. With no session this must yield [] and let the route
  // guard redirect: the sidebar has no error boundary above it, and a throw
  // here used to blank the whole application after a browser restart.
  const storedRole = getStoredAuthUser()?.role;
  const role = Array.isArray(storedRole) ? storedRole : [];

  // Feeds the "En attente de validation" badge in the sidebar.
  const pendingProductsQ = usePendingProducts({ pageSize: 1 });
  const pendingProductsCount = pendingProductsQ.data?.count ?? 0;

  // Feeds the "Experts" badge: applications from the mobile app awaiting the
  // committee (validation) or an admin (approval). The endpoint answers 403
  // to any other role, hence `enabled`.
  const canReviewExperts = role.includes("admin") || role.includes("commite");
  const pendingExpertsQ = usePendingExpertRequests({
    staleTime: 60_000,
    enabled: canReviewExperts,
  });
  const pendingExpertsCount = Array.isArray(pendingExpertsQ.data)
    ? pendingExpertsQ.data.length
    : 0;
  //state data
  const [isDashboard, setIsDashboard] = useState(false);
  const [isComptes, setIsComptes] = useState(false);
  const [isContacts, setIsContacts] = useState(false);
  const [isParticuliers, setIsParticuliers] = useState(false);
  const [isEntreprises, setIsEntreprises] = useState(false);
  const [isOpportunites, setIsOpportunites] = useState(false);
  const [isAbonnements, setIsAbonnements] = useState(false);
  const [isApps, setIsApps] = useState(false);
  const [isAuth, setIsAuth] = useState(false);
  const [isPages, setIsPages] = useState(false);
  const [isBaseUi, setIsBaseUi] = useState(false);
  const [isAdvanceUi, setIsAdvanceUi] = useState(false);
  const [isForms, setIsForms] = useState(false);
  const [isTables, setIsTables] = useState(false);
  const [isCharts, setIsCharts] = useState(false);
  const [isIcons, setIsIcons] = useState(false);
  const [isMaps, setIsMaps] = useState(false);
  const [isCatalogue, setIsCatalogue] = useState(false);
  const [isVente, setIsVente] = useState(false);
  const [isMetiers, setIsMetiers] = useState(false);
  const [isOrganisme, setIsOrganisme] = useState(false);
  const [isDocuments, setIsDocuments] = useState(false);
  const [isAgenda, setIsAgenda] = useState(false);
  const [isTaches, setIsTaches] = useState(false);
  const [isFichiers, setIsFichiers] = useState(false);
  const [isEntreprise, setisEntreprise] = useState(false);
  const [isDeals, setIsDeals] = useState(false);
  const [isLeads, setIsLeads] = useState(false);
  const [isAppelOffres, setIsAppelOffres] = useState(false);
  const [isExperts, setIsExperts] = useState(false);
  const [isEcommerce, setIsEcommerce] = useState(false);
  const [isUsers, setIsUsers] = useState(false);
  const [isAddCategory, setIsAddCategory] = useState(false);
  const [isStock, setIsStock] = useState(false);
  const [isPartenaire, setIsPartenaire] = useState(false);
  const [isAbonnement, setIsAbonnement] = useState(false);
  const [isSettings, setIsSettings] = useState(false);
  const [isMessagerie, setIsMessagerie] = useState(false);
  const [isFormations, setIsFormations] = useState(false);
  const [isInnovations, setIsInnovations] = useState(false);
  const [isPromotedProducts, setIsPromotedProducts] = useState(false);
  const [isAssistances, setIsAssistances] = useState(false);
  const [isPublicties, setIsPublicties] = useState(false);
  const [isFonctions, setIsFonctions] = useState(false);
  const [isLevel, setIsLevel] = useState(false);
  const [isFormationsPro, setIsFormationsPro] = useState(false);
  const [particular, setIsParticular] = useState(false);
  const [isQuestions, setIsQuestions] = useState(false);
  const [isOrganismes, setIsOrganismes] = useState(false);
  const [isProfessional, setIsProfessional] = useState(false);
  const [userCategories, setUserCategories] = useState(false);

  // Pages
  const [isProfile, setIsProfile] = useState(false);
  const [isLanding, setIsLanding] = useState(false);
  const [isBank, setIsBank] = useState(false);

  //Geolocalisation
  const [isArrondissement, setIsArrondissement] = useState(false);
  const [isQuartier, setIsQuartier] = useState(false);

  const [iscurrentState, setIscurrentState] = useState("Dashboard");

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id).classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
    if (iscurrentState !== "Dashboard") {
      setIsDashboard(false);
    }
    if (iscurrentState !== "Apps") {
      setIsApps(false);
    }
    if (iscurrentState !== "Banques") {
      setIsBank(false);
    }
    if (iscurrentState !== "Niveau de formation") {
      setIsLevel(false);
    }
    if (iscurrentState !== "Fonction") {
      setIsFonctions(false);
    }
    if (iscurrentState !== "Auth") {
      setIsAuth(false);
    }
    if (iscurrentState !== "Pages") {
      setIsPages(false);
    }
    if (iscurrentState !== "BaseUi") {
      setIsBaseUi(false);
    }
    if (iscurrentState !== "AdvanceUi") {
      setIsAdvanceUi(false);
    }
    if (iscurrentState !== "Forms") {
      setIsForms(false);
    }
    if (iscurrentState !== "Tables") {
      setIsTables(false);
    }
    if (iscurrentState !== "Charts") {
      setIsCharts(false);
    }
    if (iscurrentState !== "Icons") {
      setIsIcons(false);
    }
    if (iscurrentState !== "Maps") {
      setIsMaps(false);
    }

    if (iscurrentState !== "Particuliers") {
      setIsParticular(false);
    }

    if (iscurrentState === "Widgets") {
      history.push("/widgets");
      document.body.classList.add("twocolumn-panel");
    }
    if (iscurrentState !== "Landing") {
      setIsLanding(false);
    }
    if (iscurrentState !== "Contacts") {
      setIsContacts(false);
    }
    if (iscurrentState !== "Abonnements") {
      setIsAbonnements(false);
    }
    if (iscurrentState !== "Vente") {
      setIsVente(false);
    }
    if (iscurrentState !== "Metiers") {
      setIsMetiers(false);
    }
    if (iscurrentState !== "Opportunites") {
      setIsOpportunites(false);
    }

    if (iscurrentState !== "Formations Professionnelles") {
      setIsFormationsPro(false);
    }

    if (iscurrentState !== "Documents") {
      setIsDocuments(false);
    }
    if (iscurrentState !== "Agenda") {
      setIsAgenda(false);
    }
    if (iscurrentState !== "Taches") {
      setIsTaches(false);
    }
    if (iscurrentState !== "Fichiers") {
      setIsFichiers(false);
    }
    if (iscurrentState !== "Entreprise") {
      setisEntreprise(false);
    }
    if (iscurrentState !== "Entreprises") {
      setIsEntreprises(false);
    }
    if (iscurrentState !== "Particuliers") {
      setIsParticuliers(false);
    }
    if (iscurrentState !== "Deals") {
      setIsDeals(false);
    }
    if (iscurrentState !== "Leads") {
      setIsLeads(false);
    }
    if (iscurrentState !== "Utilisateurs") {
      setIsUsers(false);
    }
    if (iscurrentState !== "Catégories des Utilisateurs") {
      setUserCategories(false);
    }
    if (iscurrentState !== "Comptes") {
      setIsComptes(false);
    }
    if (iscurrentState !== "Gestion des Stocks") {
      setIsStock(false);
    }
    if (iscurrentState !== "Partenaires") {
      setIsPartenaire(false);
    }
    if (iscurrentState !== "Abonnements") {
      setIsAbonnement(false);
    }
    if (iscurrentState !== "Messageries") {
      setIsMessagerie(false);
    }
    if (iscurrentState !== "Appel d'Offres") {
      setIsAppelOffres(false);
    }
    if (iscurrentState !== "Experts") {
      setIsExperts(false);
    }
    if (iscurrentState !== "Settings") {
      setIsSettings(false);
    }
    if (iscurrentState !== "Formations") {
      setIsFormations(false);
    }
    if (iscurrentState !== "Innovations") {
      setIsInnovations(false);
    }
    if (iscurrentState !== "PromotedProducts") {
      setIsPromotedProducts(false);
    }
    if (iscurrentState !== "Assistances") {
      setIsAssistances(false);
    }
    if (iscurrentState !== "Publicites") {
      setIsPublicties(false);
    }
    if (iscurrentState !== "Questions/Réponses") {
      setIsQuestions(false);
    }
    if (iscurrentState !== "Organisme") {
      setIsOrganismes(false);
    }
    if (iscurrentState !== "Professional") {
      setIsProfessional(false);
    }
    if (iscurrentState !== "Organisme") {
      setIsOrganisme(false);
    }
    if (iscurrentState !== "Arrondissement") {
      setIsArrondissement(false);
    }
    if (iscurrentState !== "Quartier") {
      setIsQuartier(false);
    }
  }, [
    history,
    isOrganisme,
    iscurrentState,
    isDashboard,
    isApps,
    isAuth,
    isPages,
    isBaseUi,
    isAdvanceUi,
    isForms,
    isTables,
    isCharts,
    isIcons,
    isMaps,
    isContacts,
    isParticuliers,
    isEntreprises,
    isCatalogue,
    isVente,
    isAgenda,
    isDocuments,
    isTaches,
    isFichiers,
    isEntreprise,
    isLeads,
    isDeals,
    isUsers,
    userCategories,
    isComptes,
    isStock,
    isPartenaire,
    isAbonnement,
    isMessagerie,
    isOpportunites,
    isAppelOffres,
    isExperts,
    isFormations,
    isInnovations,
    isPromotedProducts,
    isAssistances,
    isPublicties,
    isFonctions,
    isLevel,
    isFormationsPro,
    isQuestions,
    isOrganismes,
    isProfessional,
    isBank,
    isArrondissement,
    isQuartier,
  ]);
  const menuItems = [
    {
      label: "MENU",
      className: "cursor-pointer",
      isHeader: true,
    },
    {
      id: "Dashboard",
      label: "Dashboard",
      className: "cursor-pointer",
      icon: "ri-dashboard-2-line",
      link: "/dashboard",
      stateVariables: isDashboard,
      click: function (e) {
        // e.preventDefault();
        setIsDashboard(!isDashboard);
        setIscurrentState("Dashboard");
        updateIconSidebar(e);
      },
    },
    {
      id: "comptes",
      label: "Comptes",
      className: "cursor-pointer",
      icon: "ri-account-circle-fill",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsComptes(!isComptes);
        setIscurrentState("Comptes");
        updateIconSidebar(e);
      },
      stateVariables: isComptes,
      subItems: [
        {
          id: "categories",
          label: "Catégories d'institutions",
          className: "cursor-pointer",
          link: "/utilisateurs-categories",
          isChildItem: false,
          click: function (e) {
            // e.preventDefault();
            setUserCategories(!isUsers);
          },
        },
        {
          id: "institutions",
          label: "Sous-Catégories d'institutions",
          className: "cursor-pointer",
          link: "/utilisateurs-institutions",
          isChildItem: false,
          click: function (e) {
            setUserCategories(!isUsers);
          },
        },
        {
          id: "utilisateurs",
          label: "Utilisateurs",
          className: "cursor-pointer",
          link: "/pages-team",
          isChildItem: false,
          click: function (e) {
            e.preventDefault();
            setIsUsers(!isUsers);
          },
        },
        {
          id: "comptes-internes",
          label: "Comptes internes",
          className: "cursor-pointer",
          link: "/pages-team-add-staff",
          isChildItem: false,
          click: function (e) {
            e.preventDefault();
            setIsUsers(!isUsers);
          },
        },
        ...(isLegacyCrmEnabled
          ? [
              {
                id: "entreprise",
                label: "Collaborateurs",
                className: "cursor-pointer",
                icon: "ri-apps-2-line",
                link: "/collaborateurs",
                click: function (e) {
                  // e.preventDefault();
                  setisEntreprise(!isEntreprise);
                  setIscurrentState("Entreprise");
                  updateIconSidebar(e);
                },
                stateVariables: isEntreprise,
              },
            ]
          : []),
        {
          id: "profil",
          label: "Profil",
          className: "cursor-pointer",
          link: "/pages-profile",
          isChildItem: false,
          click: function (e) {
            e.preventDefault();
            setIsProfile(!isProfile);
          },
        },
      ],
    },
    { label: "GEOLOCALISATION", isHeader: true },
    {
      id: "arrondissement",
      label: "Arrondissement",
      className: "cursor-pointer",
      icon: "ri-map-pin-line",
      link: "/geolocalisation-arrondissement",
      stateVariables: isArrondissement,
      click: function (e) {
        // e.preventDefault();
        setIsArrondissement(!isArrondissement);
        setIscurrentState("Arrondissement");
        updateIconSidebar(e);
      },
    },
    {
      id: "quartier",
      label: "Quartier",
      className: "cursor-pointer",
      icon: "ri-community-line",
      link: "/geolocalisation-quartier",
      stateVariables: isQuartier,
      click: function (e) {
        // e.preventDefault();
        setIsQuartier(!isQuartier);
        setIscurrentState("Quartier");
        updateIconSidebar(e);
      },
    },
    {
      label: "ARTICLES",
      className: "cursor-pointer",
      isHeader: true,
    },
    {
      id: "",
      label: "Articles",
      className: "cursor-pointer",
      icon: "ri-book-open-line",
      link: "/articles",
      stateVariables: isEcommerce,
      click: function (e) {
        // e.preventDefault();
        setIsEcommerce(!isEcommerce);
        setIscurrentState("Articles");
        updateIconSidebar(e);
      },
    },
    {
      id: "catalogue",
      label: "Type d'articles",
      className: "cursor-pointer",
      link: "/categories",
      icon: "ri-book-open-line",
      click: function (e) {
        // e.preventDefault();
        setIsCatalogue(!isCatalogue);
        setIscurrentState("Catalogue");
        updateIconSidebar(e);
      },
    },

    {
      label: "FORMATIONS",
      className: "cursor-pointer",
      isHeader: true,
    },
    {
      id: "formations",
      label: "Formations",
      className: "cursor-pointer",
      icon: "ri-book-2-line",
      link: "/formations",
      stateVariables: isFormations,
      click: function (e) {
        // e.preventDefault();
        setIsFormations(!isFormations);
        setIscurrentState("Formations");
        updateIconSidebar(e);
      },
    },
    {
      label: "PROFESSIONNELS",
      className: "cursor-pointer",
      isHeader: true,
    },
    {
      id: "level",
      label: "Niveau de formation",
      className: "cursor-pointer",
      icon: "ri-bar-chart-grouped-fill",
      link: "/level",
      stateVariables: isLevel,
      click: function (e) {
        // e.preventDefault();
        setIsLevel(!isLevel);
        setIscurrentState("Niveau de formation");
        updateIconSidebar(e);
      },
    },

    {
      id: "formation-pro",
      label: "Formations Pro",
      className: "cursor-pointer",
      icon: "ri-shopping-bag-fill",
      link: "/formationspro",
      stateVariables: isFormationsPro,
      click: function (e) {
        // e.preventDefault();
        setIsFormationsPro(!isFormationsPro);
        setIscurrentState("Formations Professionnelles");
        updateIconSidebar(e);
      },
    },

    {
      id: "fonction",
      label: "Fonctions",
      className: "cursor-pointer",
      icon: "ri-briefcase-fill",
      link: "/functions",
      stateVariables: isFonctions,
      click: function (e) {
        // e.preventDefault();
        setIsFonctions(!isFonctions);
        setIscurrentState("Fonctions");
        updateIconSidebar(e);
      },
    },
    {
      id: "Metiers",
      label: "Metiers",
      className: "cursor-pointer",
      icon: "ri-funds-box-line",
      link: "/jobs",
      click: function (e) {
        // e.preventDefault();
        setIsMetiers(!isMetiers);
        setIscurrentState("Vente");
        updateIconSidebar(e);
      },
      stateVariables: isMetiers,
    },
    {
      label: "PARAMÈTRES",
      className: "cursor-pointer",
      isHeader: true,
    },
    {
      id: "app-version",
      label: "Version de l'application",
      className: "cursor-pointer",
      icon: "ri-smartphone-line",
      link: "/settings/app-version",
      stateVariables: isSettings,
      click: function (e) {
        setIsSettings(!isSettings);
        setIscurrentState("Settings");
        updateIconSidebar(e);
      },
    },
    {
      label: "EXPERT",
      className: "cursor-pointer",
      isHeader: true,
    },
    {
      id: "experts",
      label: "Experts",
      className: "cursor-pointer",
      icon: "ri-user-voice-fill",
      link: "/experts",
      // Badge shows how many expert applications are waiting for a decision.
      badgeName: pendingExpertsCount > 0 ? String(pendingExpertsCount) : null,
      badgeColor: "warning",
      click: function (e) {
        // e.preventDefault();
        setIsExperts(!isExperts);
        setIscurrentState("Experts");
        updateIconSidebar(e);
      },
    },
    {
      id: "questions",
      label: "Questions/Réponses",
      className: "cursor-pointer",
      icon: "ri-questionnaire-line",
      link: "/questions-answers",
      click: function (e) {
        // e.preventDefault();
        setIsQuestions(!isQuestions);
        setIscurrentState("Questions");
        updateIconSidebar(e);
      },
    },
    {
      label: "CERTIFICATION",
      className: "cursor-pointer",
      isHeader: true,
    },
    {
      id: "certification",
      label: "Certification",
      className: "cursor-pointer",
      icon: "ri-shield-star-fill",
      link: "/certification",
      click: function (e) {
        e.preventDefault();
        setIsExperts(!isExperts);
        setIscurrentState("Certification");
        updateIconSidebar(e);
      },
    },
    {
      label: "AUTRES ACTIVITES",
      className: "cursor-pointer",
      isHeader: true,
    },
    {
      id: "publicites",
      label: "Publicités",
      className: "cursor-pointer",
      icon: "ri-advertisement-line",
      link: "/advertisements",
      stateVariables: isPublicties,
      click: function (e) {
        // e.preventDefault();
        setIsPublicties(!isPublicties);
        setIscurrentState("Publicites");
        updateIconSidebar(e);
      },
    },

    {
      id: "opportunites",
      label: "Recrutements",
      className: "cursor-pointer",
      icon: "ri-trophy-fill",
      link: "/recruitments",
      // link: "/#",
      click: function (e) {
        // e.preventDefault();
        setIsOpportunites(!isOpportunites);
        setIscurrentState("Opportunités");
        updateIconSidebar(e);
      },
      stateVariables: isOpportunites,
    },
    {
      id: "appel_offres",
      label: "Appel d'Offres",
      className: "cursor-pointer",
      icon: "ri-profile-fill",
      link: "/appels-offres",
      click: function (e) {
        // e.preventDefault();
        setIsAppelOffres(!isAppelOffres);
        setIscurrentState("Appel d'Offres");
        updateIconSidebar(e);
      },
      stateVariables: isAppelOffres,
    },

    {
      id: "innovations",
      label: "Innovations",
      className: "cursor-pointer",
      icon: "ri-alarm-warning-line",
      link: "/innovations",
      stateVariables: isInnovations,
      click: function (e) {
        // e.preventDefault();
        setIsInnovations(!isInnovations);
        setIscurrentState("Innovations");
        updateIconSidebar(e);
      },
    },

    {
      id: "promoted_products",
      label: "Promotion de produits",
      className: "cursor-pointer",
      icon: "ri-price-tag-3-line",
      link: "/#",
      stateVariables: isPromotedProducts,
      // Badge shows how many products are waiting for validation.
      badgeName: pendingProductsCount > 0 ? String(pendingProductsCount) : null,
      badgeColor: "warning",
      click: function (e) {
        e.preventDefault();
        setIsPromotedProducts(!isPromotedProducts);
        setIscurrentState("PromotedProducts");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "promoted_products_all",
          label: "Tous les produits",
          className: "cursor-pointer",
          link: "/promoted-products",
          isChildItem: false,
          parentId: "promoted_products",
        },
        {
          id: "promoted_products_pending",
          label: "En attente de validation",
          className: "cursor-pointer",
          link: "/promoted-products-pending",
          isChildItem: false,
          parentId: "promoted_products",
          badgeName:
            pendingProductsCount > 0 ? String(pendingProductsCount) : null,
          badgeColor: "warning",
        },
        {
          id: "promoted_products_categories",
          label: "Catégories",
          className: "cursor-pointer",
          link: "/promoted-products-categories",
          isChildItem: false,
          parentId: "promoted_products",
        },
      ],
    },
    {
      label: "Type d'abonnement",
      className: "cursor-pointer",
      isHeader: true,
    },

    {
      id: "type_abonnement",
      label: "Type d'abonnement",
      className: "cursor-pointer",
      icon: "ri-bill-fill",
      link: "/subscription-types",
      stateVariables: isAbonnement,
      click: function (e) {
        e.preventDefault();
        setIsAbonnement(!isAbonnement);
        setIscurrentState("Abonnement");
        updateIconSidebar(e);
      },
    },

    {
      label: "Clientèle",
      className: "cursor-pointer",
      isHeader: true,
    },
    {
      id: "assistance",
      label: "Assistance technique",
      className: "cursor-pointer",
      icon: "ri-customer-service-2-fill",
      link: "/technical-support",
      stateVariables: isAssistances,
      click: function (e) {
        e.preventDefault();
        setIsAssistances(!isAssistances);
        setIscurrentState("Assistances");
        updateIconSidebar(e);
      },
    },
  ];
  const menuItemsCommite = [
    {
      label: "MENU",
      className: "cursor-pointer",
      isHeader: true,
    },
    {
      id: "Dashboard",
      label: "Dashboard",
      className: "cursor-pointer",
      icon: "ri-dashboard-2-line",
      link: "/dashboard",
      stateVariables: isDashboard,
      click: function (e) {
        // e.preventDefault();
        setIsDashboard(!isDashboard);
        setIscurrentState("Dashboard");
        updateIconSidebar(e);
      },
    },
    {
      id: "comptes",
      label: "Comptes",
      className: "cursor-pointer",
      icon: "ri-account-circle-fill",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsComptes(!isComptes);
        setIscurrentState("Comptes");
        updateIconSidebar(e);
      },
      stateVariables: isComptes,
      subItems: [
        {
          id: "utilisateurs",
          label: "Utilisateurs",
          className: "cursor-pointer",
          link: "/pages-team",
          isChildItem: false,
          click: function (e) {
            e.preventDefault();
            setIsUsers(!isUsers);
          },
        },

        {
          id: "profil",
          label: "Profil",
          className: "cursor-pointer",
          link: "/pages-profile",
          isChildItem: false,
          click: function (e) {
            e.preventDefault();
            setIsProfile(!isProfile);
          },
        },
      ],
    },
    {
      label: "ARTICLES",
      className: "cursor-pointer",
      isHeader: true,
    },
    {
      id: "catalogue",
      label: "Articles",
      className: "cursor-pointer",
      icon: "ri-book-open-line",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsEcommerce(!isEcommerce);
        setIscurrentState("Articles");
        updateIconSidebar(e);
      },
      stateVariables: isCatalogue,
      subItems: [
        {
          id: "produits",
          label: "Articles",
          className: "cursor-pointer",
          link: "/apps-articles",
          isChildItem: false,
          click: function (e) {
            e.preventDefault();
            setIsEcommerce(!isEcommerce);
          },
        },
      ],
    },
    {
      label: "FORMATIONS",
      className: "cursor-pointer",
      isHeader: true,
    },
    {
      id: "formations",
      label: "Formations",
      className: "cursor-pointer",
      icon: "ri-book-2-line",
      link: "/formations",
      stateVariables: isFormations,
      click: function (e) {
        e.preventDefault();
        setIsFormations(!isFormations);
        setIscurrentState("Formations");
        updateIconSidebar(e);
      },
    },
    {
      label: "PARAMÈTRES",
      className: "cursor-pointer",
      isHeader: true,
    },
    {
      id: "app-version",
      label: "Version de l'application",
      className: "cursor-pointer",
      icon: "ri-smartphone-line",
      link: "/settings/app-version",
      stateVariables: isSettings,
      click: function (e) {
        setIsSettings(!isSettings);
        setIscurrentState("Settings");
        updateIconSidebar(e);
      },
    },
    {
      label: "EXPERT",
      className: "cursor-pointer",
      isHeader: true,
    },
    {
      id: "experts",
      label: "Experts",
      className: "cursor-pointer",
      icon: "ri-user-voice-fill",
      link: "/experts",
      // Badge shows how many expert applications are waiting for a decision.
      badgeName: pendingExpertsCount > 0 ? String(pendingExpertsCount) : null,
      badgeColor: "warning",
      click: function (e) {
        // e.preventDefault();
        setIsExperts(!isExperts);
        setIscurrentState("Experts");
        updateIconSidebar(e);
      },
    },
    {
      id: "questions",
      label: "Questions/Réponses",
      className: "cursor-pointer",
      icon: "ri-questionnaire-line",
      link: "/questions-answers",
      click: function (e) {
        e.preventDefault();
        setIsQuestions(!isQuestions);
        setIscurrentState("Questions");
        updateIconSidebar(e);
      },
    },
    {
      label: "AUTRES ACTIVITES",
      className: "cursor-pointer",
      isHeader: true,
    },
    {
      id: "publicites",
      label: "Publicités",
      className: "cursor-pointer",
      icon: "ri-advertisement-line",
      link: "/advertisements",
      stateVariables: isPublicties,
      click: function (e) {
        e.preventDefault();
        setIsPublicties(!isPublicties);
        setIscurrentState("Publicites");
        updateIconSidebar(e);
      },
    },
    {
      id: "innovations",
      label: "Innovations",
      className: "cursor-pointer",
      icon: "ri-alarm-warning-line",
      link: "/innovations",
      stateVariables: isInnovations,
      click: function (e) {
        setIsInnovations(!isInnovations);
        setIscurrentState("Innovations");
        updateIconSidebar(e);
      },
    },

    {
      label: "Type d'abonnement",
      className: "cursor-pointer",
      isHeader: true,
    },

    {
      id: "type_abonnement",
      label: "Type d'abonnement",
      className: "cursor-pointer",
      icon: "ri-bill-fill",
      link: "/subscription-types",
      stateVariables: isAbonnement,
      click: function (e) {
        e.preventDefault();
        setIsAbonnement(!isAbonnement);
        setIscurrentState("Abonnement");
        updateIconSidebar(e);
      },
    },

    {
      label: "Clientèle",
      className: "cursor-pointer",
      isHeader: true,
    },
    {
      id: "assistance",
      label: "Assistance technique",
      className: "cursor-pointer",
      icon: "ri-customer-service-2-fill",
      link: "/technical-support",
      stateVariables: isAssistances,
      click: function (e) {
        e.preventDefault();
        setIsAssistances(!isAssistances);
        setIscurrentState("Assistances");
        updateIconSidebar(e);
      },
    },
  ];
  const menuItemsAssistant = [
    {
      label: "MENU",
      className: "cursor-pointer",
      isHeader: true,
    },
    {
      id: "Dashboard",
      label: "Dashboard",
      className: "cursor-pointer",
      icon: "ri-dashboard-2-line",
      link: "/#",
      stateVariables: isDashboard,
      click: function (e) {
        e.preventDefault();
        setIsDashboard(!isDashboard);
        setIscurrentState("Dashboard");
        updateIconSidebar(e);
      },
    },
    {
      id: "comptes",
      label: "Comptes",
      className: "cursor-pointer",
      icon: "ri-account-circle-fill",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsComptes(!isComptes);
        setIscurrentState("Comptes");
        updateIconSidebar(e);
      },
      stateVariables: isComptes,
      subItems: [
        {
          id: "utilisateurs",
          label: "Utilisateurs",
          className: "cursor-pointer",
          link: "/pages-team",
          isChildItem: false,
          click: function (e) {
            e.preventDefault();
            setIsUsers(!isUsers);
          },
        },
        {
          id: "profil",
          label: "Profil",
          className: "cursor-pointer",
          link: "/pages-profile",
          isChildItem: false,
          click: function (e) {
            e.preventDefault();
            setIsProfile(!isProfile);
          },
        },
      ],
    },
    {
      label: "ARTICLES",
      className: "cursor-pointer",
      isHeader: true,
    },
    {
      id: "catalogue",
      label: "Articles",
      className: "cursor-pointer",
      icon: "ri-book-open-line",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsEcommerce(!isCatalogue);
        setIscurrentState("Catalogue");
        updateIconSidebar(e);
      },
      stateVariables: isCatalogue,
      subItems: [
        {
          id: "addcategory",
          label: "Type d'articles",
          className: "cursor-pointer",
          link: "/categories",
          isChildItem: false,
          click: function (e) {
            e.preventDefault();
            setIsAddCategory(!isAddCategory);
          },
        },
        {
          id: "produits",
          label: "Articles",
          className: "cursor-pointer",
          link: "/articles",
          isChildItem: false,
          click: function (e) {
            e.preventDefault();
            setIsEcommerce(!isEcommerce);
          },
        },
      ],
    },
    {
      label: "FORMATIONS",
      className: "cursor-pointer",
      isHeader: true,
    },
    {
      id: "formations",
      label: "Formations",
      className: "cursor-pointer",
      icon: "ri-book-2-line",
      link: "/formations",
      stateVariables: isFormations,
      click: function (e) {
        e.preventDefault();
        setIsFormations(!isFormations);
        setIscurrentState("Formations");
        updateIconSidebar(e);
      },
    },

    {
      label: "AUTRES ACTIVITES",
      className: "cursor-pointer",
      isHeader: true,
    },
    {
      id: "publicites",
      label: "Publicités",
      className: "cursor-pointer",
      icon: "ri-advertisement-line",
      link: "/advertisements",
      stateVariables: isPublicties,
      click: function (e) {
        e.preventDefault();
        setIsPublicties(!isPublicties);
        setIscurrentState("Publicites");
        updateIconSidebar(e);
      },
    },

    {
      id: "opportunites",
      label: "Recrutements",
      className: "cursor-pointer",
      icon: "ri-trophy-fill",
      link: "/recruitments",
      // link: "/#",
      click: function (e) {
        // e.preventDefault();
        setIsOpportunites(!isOpportunites);
        setIscurrentState("Opportunités");
        updateIconSidebar(e);
      },
      stateVariables: isOpportunites,
    },
    {
      id: "appel_offres",
      label: "Appel d'Offres",
      className: "cursor-pointer",
      icon: "ri-profile-fill",
      link: "/appels-offres",
      click: function (e) {
        // e.preventDefault();
        setIsAppelOffres(!isAppelOffres);
        setIscurrentState("Appel d'Offres");
        updateIconSidebar(e);
      },
      stateVariables: isAppelOffres,
    },

    {
      id: "innovations",
      label: "Innovations",
      className: "cursor-pointer",
      icon: "ri-alarm-warning-line",
      link: "/innovations",
      stateVariables: isInnovations,
      click: function (e) {
        setIsInnovations(!isInnovations);
        setIscurrentState("Innovations");
        updateIconSidebar(e);
      },
    },

    {
      label: "Type d'abonnement",
      className: "cursor-pointer",
      isHeader: true,
    },

    {
      id: "type_abonnement",
      label: "Type d'abonnement",
      className: "cursor-pointer",
      icon: "ri-bill-fill",
      link: "/subscription-types",
      stateVariables: isAbonnement,
      click: function (e) {
        e.preventDefault();
        setIsAbonnement(!isAbonnement);
        setIscurrentState("Abonnement");
        updateIconSidebar(e);
      },
    },

    {
      label: "Clientèle",
      className: "cursor-pointer",
      isHeader: true,
    },
    {
      id: "assistance",
      label: "Assistance technique",
      className: "cursor-pointer",
      icon: "ri-customer-service-2-fill",
      link: "/technical-support",
      stateVariables: isAssistances,
      click: function (e) {
        e.preventDefault();
        setIsAssistances(!isAssistances);
        setIscurrentState("Assistances");
        updateIconSidebar(e);
      },
    },
  ];
  const menuItemsExpert = [
    {
      label: "MENU",
      className: "cursor-pointer",
      isHeader: true,
    },
    {
      id: "Dashboard",
      label: "Dashboard",
      className: "cursor-pointer",
      icon: "ri-dashboard-2-line",
      link: "/#",
      stateVariables: isDashboard,
      click: function (e) {
        e.preventDefault();
        setIsDashboard(!isDashboard);
        setIscurrentState("Dashboard");
        updateIconSidebar(e);
      },
    },
    {
      id: "comptes",
      label: "Comptes",
      className: "cursor-pointer",
      icon: "ri-account-circle-fill",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsComptes(!isComptes);
        setIscurrentState("Comptes");
        updateIconSidebar(e);
      },
      stateVariables: isComptes,
      subItems: [
        {
          id: "utilisateurs",
          label: "Utilisateurs",
          className: "cursor-pointer",
          link: "/pages-team",
          isChildItem: false,
          click: function (e) {
            e.preventDefault();
            setIsUsers(!isUsers);
          },
        },
        {
          id: "profil",
          label: "Profil",
          className: "cursor-pointer",
          link: "/pages-profile",
          isChildItem: false,
          click: function (e) {
            e.preventDefault();
            setIsProfile(!isProfile);
          },
        },
      ],
    },

    {
      label: "PARAMÈTRES",
      className: "cursor-pointer",
      isHeader: true,
    },
    {
      id: "app-version",
      label: "Version de l'application",
      className: "cursor-pointer",
      icon: "ri-smartphone-line",
      link: "/settings/app-version",
      stateVariables: isSettings,
      click: function (e) {
        setIsSettings(!isSettings);
        setIscurrentState("Settings");
        updateIconSidebar(e);
      },
    },
    {
      label: "EXPERT",
      className: "cursor-pointer",
      isHeader: true,
    },
    {
      id: "questions",
      label: "Questions/Réponses",
      className: "cursor-pointer",
      icon: "ri-questionnaire-line",
      link: "/questions-answers",
      click: function (e) {
        e.preventDefault();
        setIsQuestions(!isQuestions);
        setIscurrentState("Questions");
        updateIconSidebar(e);
      },
    },
  ];
  const menuItemsParticulier = [
    {
      id: "Dashboard",
      label: "Dashboard",
      className: "cursor-pointer",
      classname: "cursor-pointer",
      icon: "ri-dashboard-2-line",
      link: "/#",
      stateVariables: isDashboard,
      click: function (e) {
        e.preventDefault();
        setIsDashboard(!isDashboard);
        setIscurrentState("Dashboard");
        updateIconSidebar(e);
      },
    },
    {
      id: "comptes",
      label: "Comptes",
      className: "cursor-pointer",
      icon: "ri-account-circle-fill",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsComptes(!isComptes);
        setIscurrentState("Comptes");
        updateIconSidebar(e);
      },
      stateVariables: isComptes,
      subItems: [
        {
          id: "profil",
          label: "Profil",
          className: "cursor-pointer",
          link: "/pages-profile",
          isChildItem: false,
          click: function (e) {
            e.preventDefault();
            setIsProfile(!isProfile);
          },
        },
      ],
    },
  ];

  return (
    <React.Fragment>
      {role.some((role) => role === "admin")
        ? menuItems
        : role.some((role) => role === "commite")
        ? menuItemsCommite
        : role.some((role) => role === "expert")
        ? menuItemsExpert
        : role.some((role) => role === "assistant")
        ? menuItemsAssistant
        : menuItemsParticulier}
    </React.Fragment>
  );
};
export default Navdata;
